import { Button, CircularProgress } from "@mui/material";
import {
  useCheckAvailabilityMutation,
  useGetSessionQuery,
  useGetUserInfoQuery,
} from '../services/api';
import { useDispatch } from 'react-redux';
import { toast } from "../features/snackbar/snackbarSlice";

export function CheckAvailabilityButton({
  guid,
}: {
  guid?: string;
}) {
  const [checkAvailability, { isLoading }] = useCheckAvailabilityMutation();
  const { data: session } = useGetSessionQuery(guid);
  const { data: user } = useGetUserInfoQuery();
  const dispatch = useDispatch();

  if (!session) {
    return null;
  }
  if (!session?.startDateTime) {
    return null;
  }
  if (!session?.seats) {
    return null;
  }
  if (!session?.unavailable) {
    return null;
  }
  if (session?.booked) {
    return null;
  }
  return (
    <Button
      disabled={isLoading || user?.role !== 'member'}
      fullWidth
      onClick={async () => {
        await checkAvailability(session!.guid)
          .unwrap()
          .then(() => {
            dispatch(
              toast({
                message: 'This session is unavailable at this time',
                severity: 'warning',
              })
            )
          })
          .catch((err: any) => {
            console.error(err)
            dispatch(
              toast({
                message: String(err),
                severity: 'error',
              })
            )
          });
      }}
      variant='contained'
    >{isLoading
      ? <CircularProgress
        size={25} />
      : 'Check Availability'}</Button>
  );
}
